import Model from 'modules/reports/orm/Model'
import Account from 'modules/reports/models/Account'

export default class User extends Model {
  id: number
  name: string
  account_id: number
  email: string

  get account() {
    return this.belongsTo(Account, this.account_id)
  }
}
